import { render, staticRenderFns } from "./statement-additional-information.vue?vue&type=template&id=4e426ab9"
import script from "./statement-additional-information.vue?vue&type=script&lang=js"
export * from "./statement-additional-information.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports